import i18n from 'i18n-js';

// Edit Changes recalls a pending change (the same call as plain Recall) and
// reopens it as a browser-local DRAFT. UCD soft-deletes the
// recalled row, so the page captures the pending body before dispatching and
// only seeds the form once the recall has succeeded.
//
// 'edits': the change updated an ACTIVE record, so it comes back as local
//   edits over that record and resubmits as an update under the same key.
// 'draft': nothing is ACTIVE (the change was a create), so it comes back as an
//   unkeyed in-memory draft and resubmits as a create, which gets a new key.
export type EditChangesMode = 'edits' | 'draft';

export interface EditChangesSeed<T> {
  mode: EditChangesMode;
  rowKey: string;
  value: T;
}

export const editChangesText = (key: string): string =>
  i18n.t(`ucd_content_config.edit_changes.${key}`);
